import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ClientRedirect from '../components/ClientRedirect.jsx';
import './HelpFAQPage.css';

const helpDocuments = {
  faq01: '/documentation/faqs/faq01/index.html',
  faq02: '/documentation/faqs/faq02/index.html',
  faq03: '/documentation/faqs/faq03/index.html',
  faq04: '/documentation/faqs/faq04/index.html',
  faq05: '/documentation/faqs/faq05/index.html',
  faq06: '/documentation/faqs/faq06/index.html',
  'video-guide': '/documentation/faqs/faq01/index.html',
};

const HelpFAQPage = () => {
  const { faqId } = useParams();
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState('100vh');
  const documentUrl = helpDocuments[faqId];

  const resizeIframe = useCallback(() => {
    const iframe = iframeRef.current;
    const iframeDocument = iframe?.contentDocument;

    if (!iframeDocument) {
      return;
    }

    const height = Math.max(
      iframeDocument.documentElement.scrollHeight,
      iframeDocument.body?.scrollHeight || 0
    );

    setIframeHeight(`${height}px`);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', resizeIframe);

    return () => {
      window.removeEventListener('resize', resizeIframe);
    };
  }, [resizeIframe]);

  if (!documentUrl) {
    return <ClientRedirect to="/faq" replace />;
  }

  return (
    <main className="help-faq-page">
      <iframe
        ref={iframeRef}
        src={documentUrl}
        title={`${faqId} help`}
        className="help-faq-frame"
        style={{ height: iframeHeight }}
        onLoad={resizeIframe}
      />
    </main>
  );
};

export default HelpFAQPage;
